import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTitleT = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 32V30L16.4851 29.3787C17.3754 29.1562 18 28.3562 18 27.4384V11H14.4415C13.5807 11 12.8164 11.5509 12.5441 12.3675L12 14H10V8H30V14H28L27.4559 12.3675C27.1836 11.5509 26.4193 11 25.5585 11H22V27.4384C22 28.3562 22.6246 29.1562 23.5149 29.3787L26 30V32H14Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTitleT);
export default ForwardRef;
